import Col from '../Col2.js';
import DropdownBase from "./FieldTypeBase/DropdownBase.js";
import { forwardRef } from 'react';

const DropdownBlock =  forwardRef((props, ref) => {
    return (        
        <Col 
           // {...props}
            id={props.objectkey} 
            className={`col-md-${props.field.width} field ${props.field.class || ""}`}>

            <DropdownBase {...props}  ref={ref} ></DropdownBase>
                
        </Col>
    );
});
export default DropdownBlock;